/**
 * Country Profile translations - English (Source of truth)
 */

export const countryProfile = {
  countryProfile: {
    // Page structure
    pageTitle: 'Country Profile',
    backToRankings: 'Back to Rankings',
    viewFullProfile: 'View Full Profile',
    
    // Hero section
    yfiScore: 'Youth Futures Index',
    vsGlobal: 'vs Global Average',
    classification: 'Classification',
    region: 'Region',
    
    // Quick stats
    youthPopulation: 'Youth Population',
    jciMembers: 'JCI Members',
    jciSince: 'JCI Since',
    neetRate: 'NEET Rate',
    
    // Section titles
    demographics: 'Demographics & Population',
    jciPresence: 'JCI Presence',
    dimensionAnalysis: 'Dimension Analysis',
    mentalHealth: 'Mental Health',
    workforce: 'Workforce & Education',
    entrepreneurship: 'Entrepreneurship',
    keyPrograms: 'Key Programs & Organizations',
    sdgAlignment: 'SDG Alignment',
    recommendations: 'Strategic Recommendations',
    communityImpact: 'Community Impact',
    
    // Demographics labels
    totalPopulation: 'Total Population',
    medianAge: 'Median Age',
    urbanPopulation: 'Urban Population',
    genderDistribution: 'Gender Distribution',
    racialComposition: 'Racial Composition',
    incomeDistribution: 'Income Distribution',
    
    // Racial composition
    pardo: 'Pardo (Mixed-Race)',
    preto: 'Preto (Black)',
    branco: 'Branco (White)',
    other: 'Other',
    
    // Income levels
    highIncome: 'High Income',
    upperMiddle: 'Upper-Middle',
    lowerMiddle: 'Lower-Middle',
    lowIncome: 'Low Income',
    
    // JCI Presence
    affiliationYear: 'Affiliation Year',
    currentMembers: 'Current Members',
    yearOverYearGrowth: 'Year-over-Year Growth',
    historicalPeak: 'Historical Peak',
    memberProfile: 'Member Profile',
    ageDistribution: 'Age Distribution',
    educationLevel: 'Education Level',
    genderBalance: 'Gender Balance',
    motivationLevel: 'Motivation Level',
    higherEducation: 'Higher Education',
    postGraduate: 'Post-Graduate',
    mastersOrHigher: "Master's or Higher",
    veryMotivated: 'Very Motivated',
    motivated: 'Motivated',
    neutral: 'Neutral',
    demotivated: 'Demotivated',
    
    // Challenges
    keyChallenges: 'Key Challenges',
    mentalHealthCrisis: 'Mental Health Crisis',
    climateAnxiety: 'Climate Anxiety',
    youthAnxiety: 'Youth Anxiety',
    frequentSadness: 'Frequent Sadness',
    frequentNervousness: 'Frequent Nervousness',
    adolescentDisorders: 'Adolescents with Disorders',
    girlsAffected: 'Girls Affected',
    boysAffected: 'Boys Affected',
    highestGlobally: 'Highest Globally',
    neetPopulation: 'Youth NEET',
    youth: 'Youth',
    intersectionalGap: 'Intersectional Gap',
    blackBrownWomen: 'Black/Brown Women',
    whiteMen: 'White Men',
    
    // Workforce labels
    literacyCrisis: 'Literacy Rate (2nd Year)',
    higherEducationGap: 'Higher Education Gap',
    intersectionalNeet: 'Intersectional NEET',
    
    // Entrepreneurship labels
    blackEntrepreneurs: 'Black Entrepreneurs',
    informalSector: 'In Informal Sector',
    microentrepreneurs: 'Microentrepreneurs (MEI)',
    earlyStageEntrepreneurship: 'Early-Stage Entrepreneurship',
    businessSurvivalRate: 'Business Survival (2yr)',
    
    // Programs
    programName: 'Program',
    programFocus: 'Focus',
    programImpact: 'Impact',
    
    // SDG
    sdgInitiatives: 'Key Initiatives',
    
    // Recommendations
    urgentPriorities: 'Urgent Priorities (0-6 months)',
    mediumTermGoals: 'Medium-Term Goals (6-12 months)',
    longTermVision: 'Long-Term Vision (1-3 years)',
    
    // Common
    years: 'years',
    million: 'million',
    thousand: 'thousand',
    percent: '%',
    ofPopulation: 'of population',
    source: 'Source',
    dataNote: 'Data from JCI Impact Report 2025, Atlas das Juventudes, IBGE, WHO',
    
    // Not found
    notFound: 'Country profile not found',
    notFoundDescription: 'The requested country profile is not available yet.',
    browseRankings: 'Browse Country Rankings',

    // NEW: Research Sources Section
    dataSources: 'Research Sources',
    dataSourcesDescription: 'Primary data sources used in this country profile',
    primarySources: 'Primary Sources',
    methodology: 'Methodology',
    sampleSize: 'Sample Size',
    confidenceLevel: 'Confidence Level',
    organization: 'Organization',
    researchYear: 'Year',
    respondents: 'respondents',
    
    // NEW: Violence & Safety Section
    violenceSafety: 'Violence & Safety',
    violenceSafetyDescription: 'Critical safety indicators affecting Brazilian youth',
    youthHomicideShare: 'Youth Homicide Share',
    ofAllHomicides: 'of all homicides',
    racialDisparity: 'Racial Disparity',
    blackYouthMurderRisk: 'Black youth murder risk',
    timesHigher: 'times higher than white youth',
    policeViolence: 'Police Violence',
    policeViolenceVictims: 'of police violence victims are Black',
    lgbtqiaViolence: 'LGBTQIA+ Violence',
    annualIncrease: 'annual increase in reported violence',
    
    // NEW: Organizational Health Section
    organizationalHealth: 'Organizational Health',
    organizationalHealthDescription: 'JCI Brasil member satisfaction and engagement metrics',
    netPromoterScore: 'Net Promoter Score',
    excellent: 'Excellent',
    promoters: 'Promoters',
    passives: 'Passives',
    detractors: 'Detractors',
    localSatisfaction: 'Local Org Satisfaction',
    nationalSatisfaction: 'National Org Satisfaction',
    outOfTen: 'out of 10',
    npsBreakdown: 'NPS Breakdown',
    satisfactionScores: 'Satisfaction Scores',
    
    // NEW: SWOT Analysis Section
    swotAnalysis: 'Member SWOT Analysis',
    swotAnalysisDescription: 'Strategic assessment from JCI Brasil member survey',
    strengths: 'Strengths',
    weaknesses: 'Weaknesses',
    opportunities: 'Opportunities',
    threats: 'Threats',
    membersIdentified: 'of members identified',
    
    // NEW: Geographic Distribution Section
    geographicGap: 'Geographic Distribution',
    geographicGapDescription: 'JCI Brasil membership concentration by state',
    stateConcentration: 'State Concentration',
    southRegionDominance: 'South Region Dominance',
    expansionOpportunity: 'Expansion Opportunity',
    expansionOpportunityText: 'Minimal presence in North/Northeast regions where youth development needs are greatest',
    members: 'members',
    ofMembership: 'of membership',
    
    // NEW: Training Insights Section
    trainingInsights: 'Training Participation',
    trainingInsightsDescription: 'JCI Brasil training course completion rates',
    noTrainingCompleted: 'No Training Completed',
    trainingGapAlert: 'of members have completed no JCI training courses',
    courseCompletionRates: 'Course Completion Rates',
    completionRate: 'Completion',
    
    // NEW: SDG Preferences Section  
    sdgPreferences: 'SDG Member Priorities',
    sdgPreferencesDescription: 'Top SDGs of interest among JCI Brasil members (next 3 years)',
    memberInterest: 'Member Interest',
    topPriority: 'Top Priority',
    alignsWithNationalNeeds: 'Aligns with national youth challenges',
    
    // Sample label
    sample: 'Sample',

    // SWOT Items (20 keys)
    swotItems: {
      companionship: 'Companionship',
      committedLeadership: 'Committed leadership',
      continuousTraining: 'Continuous training',
      purposeInDna: 'Purpose in DNA',
      qualityNetworking: 'Quality networking',
      inflatedEgos: 'Inflated egos',
      bureaucracy: 'Bureaucracy',
      inconclusiveProcesses: 'Inconclusive processes',
      closedOrganization: 'Closed organization',
      lackOfMarketing: 'Lack of marketing',
      grantsAndSponsorships: 'Grants and sponsorships',
      personalDevelopmentNecessity: 'Personal development necessity',
      marketDemandsNewLeaders: 'Market demands new leaders',
      digitalPlatforms: 'Digital platforms',
      digitalMarketing: 'Digital marketing',
      rapidSocietalChange: 'Rapid societal behavioral change',
      digitalEntertainment: 'Digital entertainment',
      growingNgos: 'Growing number of social NGOs',
      lackOfRecognizedProjects: 'Lack of recognized projects',
      societyWithoutTime: 'Society without time',
    },

    // SDG Titles (9 keys)
    sdgTitles: {
      qualityEducation: 'Quality Education',
      goodHealth: 'Good Health & Well-being',
      decentWork: 'Decent Work & Economic Growth',
      peaceJustice: 'Peace, Justice & Institutions',
      reducedInequalities: 'Reduced Inequalities',
      genderEquality: 'Gender Equality',
      noPoverty: 'No Poverty',
      sustainableCities: 'Sustainable Cities',
      climateAction: 'Climate Action',
    },

    // Training Courses (10 keys)
    trainingCourses: {
      jciImpact: 'JCI Impact',
      jciAchieve: 'JCI Achieve',
      projectManagement: 'Project Management',
      jciAdmin: 'JCI Admin',
      effectiveLeadership: 'Effective Leadership',
      networking: 'Networking',
      communications: 'Communications',
      presenter: 'Presenter',
      leadershipAcademy: 'Leadership Academy',
      jciDiscover: 'JCI Discover',
    },

    // Brazil-specific Demographics
    brazilDemographics: {
      urbanPopulationBrazil: 'Majority urban, ~16M in favelas',
    },

    // Research Methodologies (5 keys)
    methodologies: {
      methodologyAtlas: 'Three-stage research: quantitative analysis (IBGE data), qualitative interviews, policy recommendations',
      methodologySuaVoz: 'SurveyMonkey, 40.7% response rate, ±4% margin of error, 95% confidence',
      methodologyConjuve: 'National youth survey on attitudes and challenges',
      methodologyConvid: 'Adolescent mental health behavioral survey',
      methodologyAtlasViolencia: 'Analysis of homicide and violence data',
    },

    // Brazil-specific Recommendations (12 keys)
    brazilRecommendations: {
      urgentRec1: 'Address Black/Brown women NEET crisis (43.3% rate)',
      urgentRec2: 'Expand mental health programming for climate anxiety',
      urgentRec3: 'Launch regional chapters in North/Northeast',
      urgentRec4: 'Partner with CUFA for favela community reach',
      mediumRec1: 'Scale NextGen and JOAJU IT programs nationally',
      mediumRec2: 'Develop JCI-specific education pathways',
      mediumRec3: 'Create mental health advocate training for members',
      mediumRec4: 'Build formal partnerships with women entrepreneur networks',
      longRec1: 'Position JCI Brasil as key partner for COP 30 youth agenda',
      longRec2: 'Address demographic transition with strategic youth investment',
      longRec3: 'Achieve 50-50 gender balance with racial equity focus',
      longRec4: 'Establish presence in all 27 Brazilian states',
    },
  },
};
